(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => {
        window.clearTimeout(this.headerHeightTimer);
        this.headerHeightTimer = window.setTimeout(() => this.setHeaderHeight(), 80);
      });
      this.headerResizeObserver.observe(this);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const desktopMenu = window.matchMedia('(min-width: 1400px) and (hover: hover) and (pointer: fine) and (not (any-pointer: coarse))').matches &&
        this.querySelector('.header--top-center.header--has-menu');
      if (desktopMenu) {
        const styles = getComputedStyle(desktopMenu);
        const expandedPadding = parseFloat(getComputedStyle(document.documentElement).fontSize) * 2.8;
        const currentPadding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
        const expandedHeight = Math.ceil(this.getBoundingClientRect().height + Math.max(0, expandedPadding - currentPadding));
        this.header.style.setProperty('--zippopiu-header-slot', `${expandedHeight}px`);
        document.documentElement.style.setProperty('--header-layout-height', `${expandedHeight}px`);
      } else {
        this.header.style.removeProperty('--zippopiu-header-slot');
        document.documentElement.style.removeProperty('--header-layout-height');
      }
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.max(0, Math.floor(this.getBoundingClientRect().bottom))}px`
      );
    }

    disconnectedCallback() {
      this.headerResizeObserver.disconnect();
      window.clearTimeout(this.headerHeightTimer);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductDescriptionToggle extends HTMLElement {
    connectedCallback() {
      if (this.dataset.productDescriptionReady === 'true') return;
      this.dataset.productDescriptionReady = 'true';

      this.content = this.querySelector('.product-description-toggle__content');
      this.button = this.querySelector('.product-description-toggle__button');

      if (!this.content || !this.button) return;

      requestAnimationFrame(() => this.prepare());
      this.button.addEventListener('click', () => this.expand());
    }

    prepare() {
      this.classList.add('product-description-toggle--collapsed');
      if (this.content.scrollHeight <= this.content.clientHeight + 8) {
        this.classList.remove('product-description-toggle--collapsed');
        return;
      }
      this.button.hidden = false;
    }

    expand() {
      if (this.classList.contains('product-description-toggle--expanded')) return;

      const startHeight = `${this.content.getBoundingClientRect().height}px`;
      const endHeight = `${this.content.scrollHeight}px`;

      this.button.disabled = true;
      this.content.style.maxHeight = startHeight;
      this.content.style.overflow = 'hidden';
      this.classList.add('product-description-toggle--expanding');
      this.button.classList.add('product-description-toggle__button--leaving');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('product-description-toggle--collapsed');
          this.content.style.maxHeight = endHeight;
        });
      });

      const finish = () => {
        this.classList.remove('product-description-toggle--expanding');
        this.classList.add('product-description-toggle--expanded');
        this.content.style.maxHeight = `${this.content.scrollHeight}px`;
        this.content.style.overflow = 'hidden';
        this.button.setAttribute('aria-expanded', 'true');
        this.button.classList.add('product-description-toggle__button--hidden');
        this.button.disabled = false;
      };

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        this.content.removeEventListener('transitionend', onTransitionEnd);
        finish();
      };

      this.content.addEventListener('transitionend', onTransitionEnd);
      setTimeout(() => {
        if (!this.classList.contains('product-description-toggle--expanding')) return;
        this.content.removeEventListener('transitionend', onTransitionEnd);
        finish();
      }, 700);
    }
  }

  if (!customElements.get('product-description-toggle')) {
    customElements.define('product-description-toggle', ProductDescriptionToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrapping-furgoni-landing"] && !Shopify.designMode) return;
  try {
    
  const zpwRoot = document.querySelector('.zpw-page');
  if (zpwRoot) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = Array.from(zpwRoot.querySelectorAll('[data-zpw-reveal]'));
    const header = document.querySelector('.section-header');
    const getHeaderOffset = () => Math.ceil((header?.getBoundingClientRect().height || 0) + 16);
    const packageDetailControls = new Map();

    zpwRoot.querySelectorAll('.zpw-package-detail').forEach((details) => {
      const summary = details.querySelector('summary');
      const answer = details.querySelector('.zpw-package-detail__answer');
      if (!summary || !answer) return;

      let runningAnimation;
      let answerAnimation;
      let targetOpen = details.open;
      const setOpenState = (shouldOpen) => {
        if (targetOpen === shouldOpen) return;
        const startHeight = details.getBoundingClientRect().height;
        runningAnimation?.cancel();
        answerAnimation?.cancel();
        targetOpen = shouldOpen;

        if (prefersReducedMotion || !details.animate) {
          details.open = shouldOpen;
          details.classList.remove('is-closing');
          details.style.overflow = '';
          runningAnimation = undefined;
          return;
        }

        if (shouldOpen) {
          details.open = true;
          details.classList.remove('is-closing');
        } else {
          details.classList.add('is-closing');
        }
        const endHeight = shouldOpen ? details.offsetHeight : summary.offsetHeight + details.offsetHeight - details.clientHeight;
        details.style.overflow = 'hidden';
        const animation = details.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: 380, easing: 'cubic-bezier(.22, 1, .36, 1)' }
        );
        runningAnimation = animation;
        answerAnimation = answer.animate(
          { opacity: shouldOpen ? [0, 1] : [1, 0] },
          { duration: 260, easing: 'ease-out' }
        );
        animation.onfinish = () => {
          if (runningAnimation !== animation) return;
          if (!shouldOpen) details.open = false;
          details.classList.remove('is-closing');
          details.style.overflow = '';
          runningAnimation = undefined;
          answerAnimation = undefined;
        };
      };

      packageDetailControls.set(details, setOpenState);
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        setOpenState(!targetOpen);
      });
    });

    zpwRoot.classList.add('zpw-motion-ready');
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

      revealItems.forEach((item) => revealObserver.observe(item));
    }

    const openDesignFaqFromHash = () => {
      if (location.hash !== '#progetto-grafico') return;
      const faq = zpwRoot.querySelector('#progetto-grafico');
      if (!faq) return;
      faq.open = true;
      window.requestAnimationFrame(() => {
        const top = faq.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        faq.querySelector('summary')?.focus({ preventScroll: true });
      });
    };
    openDesignFaqFromHash();
    window.addEventListener('hashchange', openDesignFaqFromHash);

    zpwRoot.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;

        const target = zpwRoot.querySelector(targetId);
        if (!target) return;

        event.preventDefault();
        if (target instanceof HTMLDetailsElement) {
          const openPackageDetail = packageDetailControls.get(target);
          if (openPackageDetail) openPackageDetail(true);
          else target.open = true;
        }

        const packageChoice = link.dataset.zpwPackageChoice;
        if (packageChoice) {
          const packageSelect = zpwRoot.querySelector('#ZpwPackage');
          if (packageSelect) {
            packageSelect.value = packageChoice;
            packageSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const isDesktopQuote = targetId === '#preventivo' && window.matchMedia('(min-width: 990px)').matches;
        const scrollTarget = isDesktopQuote ? target.querySelector('.zpw-form') || target : target;
        const targetTop = scrollTarget.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({ top: Math.max(0, targetTop), behavior: prefersReducedMotion ? 'auto' : 'smooth' });

        if (target.matches('.zpw-faq details')) target.querySelector('summary')?.focus({ preventScroll: true });
        if (history.pushState) history.pushState(null, '', targetId);
      });
    });
  }

  document.querySelectorAll('.zpw-page .zpw-faq details').forEach((details) => {
    const answer = details.querySelector('.zpw-faq__answer');
    if (!answer) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const onHeightTransitionEnd = (callback) => {
      let fallbackTimer;
      const finish = () => {
        window.clearTimeout(fallbackTimer);
        answer.removeEventListener('transitionend', handleEnd);
        callback();
      };
      const handleEnd = (event) => {
        if (event.propertyName === 'height') finish();
      };

      answer.addEventListener('transitionend', handleEnd);
      fallbackTimer = window.setTimeout(finish, 520);
    };

    const setOpenState = (shouldOpen) => {
      if (details.dataset.zpwAnimating === 'true') return;

      if (reducedMotion) {
        details.open = shouldOpen;
        answer.style.height = shouldOpen ? 'auto' : '0px';
        return;
      }

      details.dataset.zpwAnimating = 'true';

      if (shouldOpen) {
        details.classList.remove('is-closing');
        details.open = true;
        answer.style.height = '0px';
        answer.getBoundingClientRect();
        window.requestAnimationFrame(() => {
          answer.style.height = answer.scrollHeight + 'px';
        });
        onHeightTransitionEnd(() => {
          answer.style.height = 'auto';
          details.dataset.zpwAnimating = 'false';
        });
        return;
      }

      answer.style.height = answer.scrollHeight + 'px';
      answer.getBoundingClientRect();
      window.requestAnimationFrame(() => {
        details.classList.add('is-closing');
        answer.style.height = '0px';
      });
      onHeightTransitionEnd(() => {
        details.open = false;
        details.classList.remove('is-closing');
        answer.style.height = '';
        details.dataset.zpwAnimating = 'false';
      });
    };

    details.addEventListener('click', (event) => {
      if (event.target.closest('a, button, input, textarea, select')) return;
      event.preventDefault();
      setOpenState(!details.open);
    });
  });

  document.addEventListener('input', (event) => {
    const range = event.target.closest('.zpw-page .zpw-before-after__range');
    if (!range) return;

    const stage = range.closest('[data-zpw-before-after]');
    if (stage) stage.style.setProperty('--zpw-reveal', `${range.value}%`);
  });

  const placeGoogleReviews = () => {
    const anchor = document.querySelector('[data-zpw-google-reviews]');
    const reviewWidget = document.querySelector('[class*="google_reviews_block"]');
    const reviewSection = reviewWidget && reviewWidget.closest('.shopify-section');

    if (!anchor || !reviewSection) return false;
    if (!anchor.contains(reviewSection)) anchor.append(reviewSection);
    return true;
  };

  const enableReviewAutoplay = () => {
    const reviews = document.querySelector('.zpw-google-reviews');
    if (!reviews || reviews.dataset.zpwAutoplay === 'true') return Boolean(reviews);

    const next = () => reviews.querySelector('.grp-entangle-swiper-button-next[role="button"], .grp-entangle-swiper-button-next');
    if (!next()) return false;

    let timer;
    const stop = () => window.clearInterval(timer);
    const advance = () => {
      if (document.hidden || reviews.matches(':hover') || reviews.contains(document.activeElement)) return;
      const control = next();
      if (control && !control.classList.contains('swiper-button-disabled')) control.click();
    };
    const start = () => {
      stop();
      timer = window.setInterval(advance, 5600);
    };

    reviews.dataset.zpwAutoplay = 'true';
    reviews.addEventListener('mouseenter', stop);
    reviews.addEventListener('mouseleave', start);
    reviews.addEventListener('focusin', stop);
    reviews.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
    return true;
  };

  if (!placeGoogleReviews()) {
    const reviewObserver = new MutationObserver(() => {
      if (placeGoogleReviews()) reviewObserver.disconnect();
    });
    reviewObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !enableReviewAutoplay()) {
    const autoplayObserver = new MutationObserver(() => {
      if (enableReviewAutoplay()) autoplayObserver.disconnect();
    });
    autoplayObserver.observe(document.body, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrapping-vehicles-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.zpv-page');
    if (!root) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = Array.from(root.querySelectorAll('[data-zpv-reveal]'));
    const header = document.querySelector('.section-header');
    const getHeaderOffset = () => Math.ceil((header?.getBoundingClientRect().height || 0) + 16);

    root.classList.add('zpv-motion-ready');

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -9% 0px', threshold: 0.08 });
      revealItems.forEach((item) => observer.observe(item));
    }

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;
        const target = root.querySelector(targetId);
        if (!target) return;
        event.preventDefault();
        const targetTop = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({ top: Math.max(0, targetTop), behavior: reducedMotion ? 'auto' : 'smooth' });
        if (history.pushState) history.pushState(null, '', targetId);
      });
    });

    root.querySelectorAll('[data-zpv-slider]').forEach((slider) => {
      const rail = slider.querySelector('[data-zpv-rail]');
      const previous = slider.querySelector('[data-zpv-slide="previous"]');
      const next = slider.querySelector('[data-zpv-slide="next"]');
      if (!rail || !previous || !next) return;

      const syncControls = () => {
        previous.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      };
      const move = (direction) => {
        rail.scrollBy({
          left: direction * Math.max(rail.clientWidth * 0.82, 260),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', syncControls, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(syncControls).observe(rail);
      syncControls();
    });

    root.addEventListener('input', (event) => {
      const range = event.target.closest('.zpv-before-after__range');
      if (!range) return;
      const stage = range.closest('[data-zpv-before-after]');
      if (stage) stage.style.setProperty('--zpv-reveal', `${range.value}%`);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zippodigital-display-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-zdd-page]');
    if (!root) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const header = document.querySelector('.section-header');
    const getHeaderOffset = () => Math.ceil((header?.getBoundingClientRect().height || 0) + 16);

    if (!reduceMotion) root.classList.add('zdd-motion-ready');

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const targetTop = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({ top: Math.max(0, targetTop), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    root.querySelectorAll('.zdd-faq details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        root.querySelectorAll('.zdd-faq details[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });

    root.addEventListener('input', (event) => {
      const range = event.target.closest('.zdd-before-after__range');
      if (!range) return;

      const stage = range.closest('[data-zdd-before-after]');
      if (stage) stage.style.setProperty('--zdd-reveal-position', `${range.value}%`);
    });

    if (!reduceMotion && 'IntersectionObserver' in window) {
      const elements = root.querySelectorAll('.zdd-category-card, .zdd-product-card, .zdd-project-card, .zdd-touch-card, .zdd-split-head, .zdd-before-after__stage, .zdd-service-grid li, .zdd-service-note, .zdd-software__copy, .zdd-software__media, .zdd-faq details, .zdd-contact__copy, .zdd-form');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px' });
      elements.forEach((element) => {
        const bounds = element.getBoundingClientRect();
        if (bounds.top < window.innerHeight && bounds.bottom > 0 && bounds.left < window.innerWidth && bounds.right > 0) return;
        element.classList.add('zdd-reveal');
        if (element.matches('.zdd-category-card, .zdd-product-card, .zdd-project-card, .zdd-touch-card')) element.classList.add('zdd-reveal--steady');
        observer.observe(element);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zippodigital-software"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const pages = document.querySelectorAll('[data-zds-page]');
    if (!pages.length) return;

    pages.forEach((root) => {
      if (root.dataset.zdsReady === 'true') return;
      root.dataset.zdsReady = 'true';

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      root.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const targetId = link.getAttribute('href');
          if (!targetId || targetId === '#') return;

          const target = root.querySelector(targetId);
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });

          if (history.pushState) {
            history.pushState(null, '', targetId);
          }
        });
      });

      const timezoneInput = root.querySelector('[data-zds-timezone]');
      const languageInput = root.querySelector('[data-zds-language]');
      const referrerInput = root.querySelector('[data-zds-referrer]');

      if (timezoneInput && window.Intl && Intl.DateTimeFormat) {
        timezoneInput.value = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      }

      if (languageInput) {
        languageInput.value = navigator.language || '';
      }

      if (referrerInput) {
        referrerInput.value = document.referrer || '';
      }

      const cloud = root.querySelector('.zds-software-console');
      const hero = root.querySelector('.zds-hero');

      if (cloud && hero && !prefersReducedMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let cloudFrame = 0;
        const setCloudPosition = (event) => {
          if (cloudFrame) return;

          cloudFrame = window.requestAnimationFrame(() => {
            const rect = hero.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) - .5;
            const y = ((event.clientY - rect.top) / rect.height) - .5;

            cloud.style.setProperty('--zds-cloud-x', (x * 14).toFixed(2) + 'px');
            cloud.style.setProperty('--zds-cloud-y', (y * 12).toFixed(2) + 'px');
            cloud.style.setProperty('--zds-cloud-rotate-x', (y * -5).toFixed(2) + 'deg');
            cloud.style.setProperty('--zds-cloud-rotate-y', (x * 7).toFixed(2) + 'deg');
            cloudFrame = 0;
          });
        };

        const resetCloudPosition = () => {
          cloud.style.setProperty('--zds-cloud-x', '0px');
          cloud.style.setProperty('--zds-cloud-y', '0px');
          cloud.style.setProperty('--zds-cloud-rotate-x', '0deg');
          cloud.style.setProperty('--zds-cloud-rotate-y', '0deg');
        };

        hero.addEventListener('pointermove', setCloudPosition);
        hero.addEventListener('pointerleave', resetCloudPosition);
      }

      root.querySelectorAll('.zds-faq details').forEach((details) => {
        const answer = details.querySelector('.zds-faq__answer');
        if (!answer) return;

        const onHeightTransitionEnd = (callback) => {
          let fallbackTimer;
          const finish = () => {
            window.clearTimeout(fallbackTimer);
            answer.removeEventListener('transitionend', handleEnd);
            callback();
          };
          const handleEnd = (event) => {
            if (event.propertyName !== 'height') return;
            finish();
          };

          answer.addEventListener('transitionend', handleEnd);
          fallbackTimer = window.setTimeout(finish, 520);
        };

        const setOpenState = (shouldOpen) => {
          if (details.dataset.zdsAnimating === 'true') return;

          if (prefersReducedMotion) {
            details.open = shouldOpen;
            answer.style.height = shouldOpen ? 'auto' : '0px';
            return;
          }

          details.dataset.zdsAnimating = 'true';

          if (shouldOpen) {
            details.classList.remove('is-closing');
            details.open = true;
            answer.style.height = '0px';
            answer.getBoundingClientRect();
            window.requestAnimationFrame(() => {
              answer.style.height = answer.scrollHeight + 'px';
            });

            onHeightTransitionEnd(() => {
              answer.style.height = 'auto';
              details.dataset.zdsAnimating = 'false';
            });
            return;
          }

          answer.style.height = answer.scrollHeight + 'px';
          answer.getBoundingClientRect();
          window.requestAnimationFrame(() => {
            details.classList.add('is-closing');
            answer.style.height = '0px';
          });

          onHeightTransitionEnd(() => {
            details.open = false;
            details.classList.remove('is-closing');
            answer.style.height = '';
            details.dataset.zdsAnimating = 'false';
          });
        };

        details.addEventListener('click', (event) => {
          if (event.target.closest('a, button, input, textarea, select')) return;
          event.preventDefault();
          setOpenState(!details.open);
        });
      });

      const revealItems = root.querySelectorAll(
        '.zds-section-head, .zds-split-head, .zds-feature-grid article, .zds-flow-grid article, .zds-template-callout, .zds-workflow-card, .zds-package-card, .zds-start-board, .zds-package-note, .zds-faq details, .zds-contact__grid > div, .zds-form, .zds-case-carousel, .zds-difference__grid > div'
      );

      revealItems.forEach((element, index) => {
        element.classList.add('zds-reveal');
        element.style.setProperty('--zds-delay', Math.min(index * 32, 220) + 'ms');
      });

      if (!('IntersectionObserver' in window)) {
        revealItems.forEach((element) => element.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      revealItems.forEach((element) => observer.observe(element));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
